var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("Ustawienia")]),_c('v-card-text',[_c('p',[_vm._v("W tej sekcji możesz zmienić hasło. Pamiętaj aby nie dzielić się nim z nikim.")]),_c('PasswordChangeOldRequired')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }